import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';

export const LE3_3 = () => (
  <Section>

    <UL>
      <LI>
        <P gapAfter>
          Erstellen Sie eine <b>Lebenszyklusanalyse</b> eines Kleidungsstücks aus einer Fast-Fashion-Kollektion.
          Wählen Sie hierzu z. B. Kleidungsstücke aus der Kleiderschrank-Analyse aus oder bringen Sie selbst ein Shirt mit in den Unterricht.
          In Gruppenarbeit (<b>Expertengruppen</b>) beschäftigen sich die SuS mit verschiedenen Aspekten:
        </P>

        <UL disc>
          <LI>
            Soziale Aspekte in der Herstellung: Lassen Sie die Rahmenbedingungen in den Ländern recherchieren, aus denen die meisten Kleidungsstücke aus der Kleiderschrank-Analyse stammen. Stichworte: Mindestlohn, Arbeitszeiten, Arbeitsbedingungen etc.
          </LI>
          <LI>
            Ökologische Aspekte in der Herstellung/im Gebrauch; Stichworte: Zusammensetzung der Kleidung, Giftstoffe, Baumwolle, Synthetikfasern, Ökobilanz, Wasserverbrauch, Wäsche waschen etc.
          </LI>
          <LI>
            Gebrauch/Entsorgung; Stichworte: Tragedauer, Reparatur, Entsorgung, (was passiert mit den Altkleidern?), Retouren
          </LI>
        </UL>

        <P gapBefore>
          Je nachdem wie fortgeschritten Ihre SuS sind, können Sie ohne oder mit Angabe der o. g. Stichpunkte die Aufgabe erarbeiten lassen bzw. können Sie zusätzlich noch folgende Recherchetipps geben:
        </P>
      </LI>

    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/LE3_3.js